module.exports = __webpack_public_path__ + "static/img/设计师2.13d9a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/设计师2.png
// module id = xPSR
// module chunks = 1